module.exports = __webpack_public_path__ + "static/media/sided_pc.ce65fbdc.png";